/** 页面信息 */
const page = new (function () {
  this.title = '下载日志'
  this.icon = 'iconfont iconicon_group'
  this.name = 'resource_logRecord'
  /**菜单编号 */
  this.code = 'resource_logRecord'
  /**菜单别名 */
  this.aliasName = 'resource_logRecord'
  /**路由地址 */
  this.path = '/resource/logRecord'
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
